import { GiftOffIcon } from './GiftOffIcon';

/**
 * author: Colton Wiscombe
 * id 17729CE1-90B8-4C63-A142-99056CDDC860
 * name gift-off
 * version: 5.9.55
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/gift-off.svg
 * tags
 * - Holiday 
 */
export const PresentOffIcon = GiftOffIcon;
export default PresentOffIcon